/**
 * Ad type IDs used by the API (e.g. for video vs image/PDF).
 * Use these constants instead of magic numbers.
 */
export const AD_TYPE_IDS = {
  VIDEO: 1,
  IMAGE: 2,
  PDF: 3,
}
